import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = "https://mqivqquerdcexayenrqn.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1xaXZxcXVlcmRjZXhheWVucnFuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQxMjc3MzEsImV4cCI6MjA4OTcwMzczMX0.hJ3MtgIpR2Ae8u9jrkB_OuhGHY7GP8_jWVKP4_T-QuI";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: "expertconnect-auth",
    flowType: "pkce"
  }
});